import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=1905e4ca&scoped=true&"
import script from "./Seats.vue?vue&type=script&lang=js&"
export * from "./Seats.vue?vue&type=script&lang=js&"
import style0 from "./Seats.vue?vue&type=style&index=0&id=1905e4ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905e4ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpansionPanelContent,VIcon,VRow})
